import wixWindow from 'wix-window';
import wixLocation from 'wix-location';


export function button2_click(event) {
	if ($w('#input1').value === 'POALIM'){
	//	$w('#vectorImage2').hide();
	//	$w('#vectorImage1').show();
		$w('#box2').show();
}
else if ($w('#input1').value === 'Poalim'){
		
		$w('#box2').show();
}
else if ($w('#input1').value === 'poalim'){
		
		$w('#box2').show();
}
	else
			wixWindow.openLightbox("no");
}

export function vectorImage1_click(event) {
			$w('#box3').show();
}